<template>
  <div class="view_con">
    <div class="view-search">
      <el-form :inline="true" :model="formInline" class="demo-form-inline" size="mini" ref="formInline">
        <el-form-item label="桌位号" prop="tableNo">
          <el-input v-model.trim="formInline.tableNo" clearable></el-input>
        </el-form-item>
        <el-form-item label="操作员" prop="operateNo">
          <el-input v-model.trim="formInline.operateNo" clearable></el-input>
        </el-form-item>
        <el-form-item label="桌位状态" prop="tableStatus">
          <el-select v-model="formInline.tableStatus" placeholder="请选择" clearable>
            <el-option v-for="(v, k) in equipmentstatus" :key="k" :label="v" :value="k"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="挂单类型" prop="pendingType" v-if="namezin=='4'">
          <el-select v-model="formInline.pendingType" placeholder="请选择" clearable>
            <el-option v-for="(v,k) in pendingTypeall" :key="k" :label="v" :value="k"></el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item label="清台时间">
          <el-date-picker :picker-options="pickerOptions" v-model="formInline.value1" type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"></el-date-picker>
        </el-form-item>
      </el-form>
      <div class="view-button">
        <el-button v-if="But.List.power()" type="primary" @click="searchzin" size="mini" class="serach">查询</el-button>
        <span class="view-button-rest" @click="reset">重置筛选条件</span>
      </div>
    </div>
    <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" size="mini" highlight-current-row>
      <el-table-column label="序号" type="index" :index="indexMethod"></el-table-column>
      <el-table-column prop="orderNo" label="订单号"></el-table-column>
      <el-table-column label="桌位状态">
        <template slot-scope="scope">{{
          equipmentstatus[scope.row.tableStatus]
        }}</template>
      </el-table-column>
      <el-table-column prop="tableNo" label="桌位号"></el-table-column>
      <el-table-column prop="tableName" label="桌位名称"></el-table-column>
      <el-table-column label="订单总额">
        <template slot-scope="scope">{{
          scope.row.orderPaymentAmount | money
        }}</template>
      </el-table-column>
      <el-table-column prop="orderSource" label="订单来源">
        <template slot-scope="scope">{{orderSourceMap[scope.row.orderSource]}} </template>
      </el-table-column>
      <el-table-column prop="orderSource" label="开桌来源">
        <template slot-scope="scope">{{orderSourceMap[scope.row.openTableSource]}} </template>
      </el-table-column>
      <el-table-column prop="openTableTime" label="开台时间"></el-table-column>
      <el-table-column prop="clearTableTime" label="清台时间"></el-table-column>
      <el-table-column prop="operateNo" label="操作员"></el-table-column>
    </el-table>
    <div class="view-page" style="margin-bottom: 70px">
      <el-pagination @current-change="handleCurrentChange" :current-page="page.pageNo" :page-size="page.pageSize" layout="total, prev, pager, next, jumper" :total="page.total" prev-text="上一页"
        next-text="下一页"></el-pagination>
    </div>
  </div>
</template>

<script>
import formatDate from "@/common/date.js";
import { notTodayPass } from "@/common/mixins.js";
export default {
  created() {
    let today = formatDate(new Date(), "yyyy-MM-dd");
    this.formInline.value1 = [today + " 00:00:00", today + " 23:59:59"];
  },
  props: { namezin: String },
  data() {
    return {
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate = minDate.getTime();
          if (maxDate) {
            this.choiceDate = "";
          }
        },
        disabledDate: (time) => {
          if (notTodayPass(time)) {
            return true;
          }
          const self = this;
          if (!!self.choiceDate) {
            let nums = 3 * 30 * 24 * 60 * 60 * 1000;
            let minTime = self.choiceDate - nums;
            let maxTime = self.choiceDate + nums;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        },
      },
      But: window.UserPower.serve.orderdetail,
      formInline: {
        tableNo: "",
        clearTableTmStart: "",
        clearTableTmEnd: "",
        tableStatus: "",
        value1: [],
      },
      tableData: [],
      statistics: {
        orderTatalAmount: "",
        realTotalAmount: "",
        discountAmount: "",
      },
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      orderSourceMap: {
        1: "扫码点餐",
        2: "服务台",
        3: "app",
      },
      equipmentstatus: {
        2: "就餐中",
        4: "待支付",
      },
      pendingTypeall: {
        // 1: "确认挂单",
        // 2: "未确认挂单"
      },
      paymentType: {
        1: "现金",
        2: "扫码",
        3: "刷卡",
        4: "其他",
        5: "免单",
        6: "账户支付",
      },
    };
  },
  methods: {
    searchorn(id) {
      this.$http
        .post("/cashier-api/f/order/query-orderNo", {
          orderId: id,
        })
        .then((res) => {
          this.search();
        });
    },
    reset() {
      this.$refs["formInline"].resetFields();
      this.formInline.value1 = [];
      this.formInline.value2 = [];
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.search();
    },
    indexMethod(index) {
      return (this.page.pageNo - 1) * this.page.pageSize + index + 1;
    },
    searchzin() {
      this.page.pageNo = 1;
      this.search();
    },
    search() {
      this.formInline.clearTableTmStart = this.formInline.value1
        ? this.formInline.value1[0]
        : "";
      this.formInline.clearTableTmEnd = this.formInline.value1
        ? this.formInline.value1[1]
        : "";
      this.$http
        .post("/cashier-api/f/order/getClearTableRecordList", {
          ...this.formInline,
          ...this.page,
        })
        .then((res) => {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        });
    },
    detail(id) {
      this.$router.push({
        path: "detail",
        query: { orderId: id },
      });
    },
  },
};
</script>

<style scoped>
.foter {
  width: 100%;
  height: 60px;
  position: fixed;
  bottom: 0;
  background: #ffffff;
  box-shadow: 0 -4px 6px 0 rgba(0, 0, 0, 0.1);
  left: 0;
  text-align: center;
  font-size: 16px;
  line-height: 60px;
}
.foter span {
  margin-right: 30px;
}
.foter span span {
  color: #ff6969;
}
</style>


